import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { randmarApiWithTags } from 'randmar-api-client';
export const store = configureStore({
  reducer: {
    [randmarApiWithTags.reducerPath]: randmarApiWithTags.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(randmarApiWithTags.middleware),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
